import React from "react";
import styled, { css } from "styled-components";

import { IThemeProps } from "@/styles/Theme";

export type PollOptionProps = {
  text: string;
  percent: number;
  votes: number;
  voted: boolean;
  onClick: () => void;
};

const PollOption: React.FC<PollOptionProps> = (
  props: PollOptionProps
): React.JSX.Element => {
  return (
    <Wrapper>
      <Button
        onClick={props.onClick}
        onTouchEnd={props.onClick}
        voted={props.voted}
      >
        <ResultBar $percent={props.percent} />
        <Text>{props.text}</Text>
      </Button>
      <Votes>{props.voted && `${props.votes} Stimmen`}</Votes>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  margin: 6px 7px;
`;

type ButtonProps = IThemeProps<{
  voted: boolean;
}>;
const Button = styled.div<ButtonProps>`
  position: relative;
  border-width: 1px;
  border-style: solid;
  border-color: ${(props: ButtonProps) =>
    props.voted ? "#fe0101" : "#ffffff"};
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 44px;
  cursor: ${(props: ButtonProps) => (props.voted ? "unset" : "pointer")};
  overflow: hidden;
  margin-bottom: 4px;
  font-family: "Gotham", Helvetica, Tahoma, sans-serif;
  color: #ffffff;
  ${(props: ButtonProps) => !props.voted && PressedButtonStyle};
`;

const PressedButtonStyle = css`
  &:hover {
    border-color: #495057;
    color: #495057;
    background-color: #000000;
  }
`;

type ResultBarProps = IThemeProps<{
  $percent: number;
}>;
const ResultBar = styled.div<ResultBarProps>`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background-color: #fe0101;
  border-radius: 0 8px 8px 0;
  width: ${(props: ResultBarProps) => props.$percent}%;
  transition: width 800ms ease-in;
`;

const Text = styled.span`
  position: relative;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-align: center;
  margin: 0 10px;
`;

const Votes = styled.span`
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  margin: 0 10px;
`;

export default PollOption;
